import React, { useEffect } from 'react';

import EnhancedSearchDropdown from '../../../components/EnhancedSearchDropdown';

const DocumentRepoSelect = ({
  defaultRepositoryName,
  lastSelectedRepositoryName,
  repositoryName,
  handleRepositoryName,
  documentRepositories,
}) => {
  useEffect(() => {
    const isLastSelectedRepositoryAvailable = documentRepositories.find(
      ({ searchName }) => searchName === lastSelectedRepositoryName
    );
    const repositoryNameToFetch = isLastSelectedRepositoryAvailable
      ? lastSelectedRepositoryName
      : defaultRepositoryName;

    handleRepositoryName(repositoryNameToFetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EnhancedSearchDropdown
      storeKey="DOCUMENT_REPOSITORY"
      selectOptions={documentRepositories}
      selectedValue={repositoryName}
      onChange={(value) => handleRepositoryName(value)}
      showPinned
      showRecent
      fullWidth
    />
  );
};

export default DocumentRepoSelect;
